export const ScrollIntoViewOnFocus = {
  mounted() {
    this.el.addEventListener("focus", () => {
      setTimeout(() => {
        if (!this.isElementInViewport(this.el, 140)) {
          this.el.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }, 300);
    });
  },

  // Utility to check if element is within viewport with a small margin
  isElementInViewport(el, margin = 0) {
    const rect = el.getBoundingClientRect();
    const viewHeight =
      window.innerHeight || document.documentElement.clientHeight;
    return rect.top >= 0 + margin && rect.bottom <= viewHeight - margin;
  },
};
